import { useCallback } from 'react'
import { observer } from 'mobx-react-lite'
//import branch from 'react-native-branch'
import { useFocusEffect } from 'expo-router'
import { useStore } from '../../../models'
import { CallToActionBaseCard } from './CallToActionBaseCard'
import { useThrottledCallback } from 'use-debounce'
import { events } from '../../../models/analytics/analytics-events'
import { APP_STORE_URL, PLAY_STORE_URL, WEBSITE_URL } from '../../../utils/checkStoreVersion'

export const CallToActionReferCard = observer(() => {
  const {
    analytics: { setEvent },
    session: { user },
    share: { branchReferUrl, promptShare, referBranchSubscription }
  } = useStore()

  const userId = user?._id.toString()

  const prompt = 'Come learn poker with me in Poker Power Play!'

  useFocusEffect(
    useCallback(() => {
      if (branchReferUrl) {
        //branch.openURL(branchReferUrl)
      } else {
        referBranchSubscription()
      }
    }, [branchReferUrl, referBranchSubscription])
  )

  const onPressRefer = useThrottledCallback(async () => {
    if (!userId) return
    setEvent(events.homescreen.refer_friend, {
      userId
    })
    // const buo = await branch.createBranchUniversalObject(`content/${userId}`, {
    //   title: prompt,
    //   contentDescription: 'Learn anytime, anywhere',
    //   contentMetadata: {
    //     customMetadata: {
    //       userId
    //     }
    //   }
    // })

    // const { url } = await buo.generateShortUrl(linkProperties, controlParams)
    promptShare(prompt, prompt, WEBSITE_URL)
  }, 1000)

  return (
    <CallToActionBaseCard
      onPress={onPressRefer}
      title="homeScreen.referMsg"
      buttonText="common.refer"
      horizontalBorderColor="#5BC4FF"
      verticalBorderColor="#38443F"
    />
  )
})
